import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditAttributesIcon from '@material-ui/icons/EditAttributes';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiCodeIcon from '@material-ui/icons/Code';
import MuiNotesIcon from '@material-ui/icons/Notes';
import MuiLaunchIcon from '@material-ui/icons/Launch';
import MuiErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import { useQuery } from 'react-query';

import { ERRORS } from 'utils/constants';

import * as API from '../../api';

import { WithTooltip } from 'utils/wrappers';
const DistributionJobs = API.DistributionJobs();

const styles = () => ({});

const RowButtons = props => {
  const { rowId, editing, onEditChange, releaseId, status } = props;

  const handleEditClick = () => onEditChange(rowId);
  const handleCancelClick = () => onEditChange(null);

  const {
    data: xmlFileUrl,
    isLoading: isLoadingXmlUrl,
    refetch: refetchXml,
    error: xmlFileError,
  } = useQuery(['fileUrl', 'xml', rowId], () => DistributionJobs.getFileUrl(rowId, 'xml'), {
    enabled: editing,
    retry: false,
  });

  const {
    data: logFileUrl,
    isLoading: isLoadingLogUrl,
    refetch: refetchLog,
    error: logFileError,
  } = useQuery(['fileUrl', 'xml', rowId], async () => DistributionJobs.getFileUrl(rowId, 'log'), {
    enabled: editing,
    retry: false,
  });

  const handleRetry = async () => {
    await refetchLog();
    await refetchXml();
  };

  return (
    <>
      {!editing ? (
        <>
          <WithTooltip tooltip="Reveal Row Actions" key="edit">
            <MuiIconButton onClick={handleEditClick}>
              <MuiEditAttributesIcon />
            </MuiIconButton>
          </WithTooltip>
        </>
      ) : (
        <>
          {/* View on Venice */}
          {releaseId && (
            <WithTooltip tooltip="View release on Venice">
              <a href={`https://app.venice.tech/releases/${releaseId}`} target="_blank" rel="noreferrer">
                <MuiIconButton type="submit">
                  <MuiLaunchIcon />
                </MuiIconButton>
              </a>
            </WithTooltip>
          )}
          {/* XML log, only visible for failures and success statuses */}
          {(status === 'Failed to send to DSP' || status === 'Sent to DSP') && (
            <>
              {!!xmlFileError && (
                <WithTooltip tooltip={ERRORS.DISTRIBUTION_FILE_URL.XML}>
                  <MuiIconButton type="submit" onClick={handleRetry}>
                    <MuiErrorOutlineIcon />
                  </MuiIconButton>
                </WithTooltip>
              )}
              {isLoadingXmlUrl && (
                <MuiIconButton disabled>
                  <MuiCircularProgress size={'16px'} />
                </MuiIconButton>
              )}
              {!!xmlFileUrl && (
                <WithTooltip tooltip="View XML">
                  <a href={xmlFileUrl.url} target="_blank" rel="noreferrer">
                    <MuiIconButton type="submit">
                      <MuiCodeIcon />
                    </MuiIconButton>
                  </a>
                </WithTooltip>
              )}
            </>
          )}
          {/* Error log, only available for error status */}
          {status === 'Failed to send to DSP' && (
            <>
              {!!logFileError && (
                <WithTooltip tooltip={ERRORS.DISTRIBUTION_FILE_URL.LOG}>
                  <MuiIconButton type="submit" onClick={handleRetry}>
                    <MuiErrorOutlineIcon />
                  </MuiIconButton>
                </WithTooltip>
              )}
              {isLoadingLogUrl && (
                <MuiIconButton disabled>
                  <MuiCircularProgress size={'16px'} />
                </MuiIconButton>
              )}
              {!!logFileUrl && (
                <WithTooltip tooltip="View Error Log">
                  <a href={logFileUrl.url} target="_blank" rel="noreferrer">
                    <MuiIconButton type="submit">
                      <MuiNotesIcon />
                    </MuiIconButton>
                  </a>
                </WithTooltip>
              )}
            </>
          )}
          {/* Cancel icon */}
          <WithTooltip tooltip="Cancel">
            <MuiIconButton onClick={handleCancelClick}>
              <MuiBlockIcon />
            </MuiIconButton>
          </WithTooltip>
        </>
      )}
    </>
  );
};

export default withStyles(styles)(RowButtons);
